<div class="d-flex justify-content-center">
  <div class="sa">
    <div class="sa-warning">
      <div class="sa-warning-body"></div>
      <div class="sa-warning-dot"></div>
    </div>
  </div>
</div>
